export default {
    variants: {
        outline: {
            field: {
                _disabled: {
                    borderColor: 'stroke.light',
                    color: 'text.secondary',
                    _hover: {
                        borderColor: 'stroke.light'
                    }
                },
                _focusVisible: {
                    borderColor: 'stroke.interactive',
                    boxShadow: 'none',
                    textStyle: 'mBold'
                },
                _hover: {
                    borderColor: 'stroke.interactive'
                },
                _invalid: {
                    borderColor: 'stroke.error',
                    color: 'text.error',
                    boxShadow: 'none'
                },
                _placeholder: {
                    color: 'text.secondary'
                },
                bg: 'fill.white',
                borderColor: 'stroke.medium',
                borderRadius: 'lg',
                color: 'text.secondary',
                fontSize: 'm',
                h: '48px',
                px: 1.5,
                py: 1.5
            }
        }
    },
    parts: [
        'field',
        'addon'
    ],
    defaultProps: {
        variant: 'outline'
    }
};

//# sourceMappingURL=input.js.map